var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 2000 2000",
    x: 0,
    y: 0,
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    fill: "#ffffff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 776,
    y: 200,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1096,
    y: 200,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 200,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 712,
    y: 264,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 776,
    y: 264,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 904,
    y: 264,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 968,
    y: 264,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 264,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 1096,
    y: 264,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 776,
    y: 328,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 328,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 904,
    y: 328,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 712,
    y: 392,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 776,
    y: 392,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 904,
    y: 392,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 392,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 392,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 392,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 456,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 968,
    y: 456,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 456,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 456,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 712,
    y: 520,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 520,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 520,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 1096,
    y: 520,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 520,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 712,
    y: 584,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 584,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 968,
    y: 584,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 1096,
    y: 584,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 584,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 968,
    y: 648,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 648,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 648,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 712,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 712,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 712,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 712,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 456,
    y: 712,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 584,
    y: 712,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 712,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 712,
    y: 712,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 776,
    y: 712,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 712,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 968,
    y: 712,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 712,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 1288,
    y: 712,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 1416,
    y: 712,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 1544,
    y: 712,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 1672,
    y: 712,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 776,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 776,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 776,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 776,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 776,
    y: 776,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 776,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 776,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 1288,
    y: 776,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 1416,
    y: 776,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 1480,
    y: 776,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 1736,
    y: 776,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 840,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 840,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 584,
    y: 840,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 840,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 712,
    y: 840,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 776,
    y: 840,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 904,
    y: 840,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 968,
    y: 840,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 840,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 840,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 1288,
    y: 840,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 1352,
    y: 840,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 1480,
    y: 840,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 1608,
    y: 840,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 904,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 904,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 904,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 904,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 712,
    y: 904,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 776,
    y: 904,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 904,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 904,
    y: 904,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 1096,
    y: 904,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 904,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 1288,
    y: 904,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 968,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 968,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 584,
    y: 968,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 968,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 776,
    y: 968,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 904,
    y: 968,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 1096,
    y: 968,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 968,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 1352,
    y: 968,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 1416,
    y: 968,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 1480,
    y: 968,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 1544,
    y: 968,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 1672,
    y: 968,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 1736,
    y: 968,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 1032,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 1032,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 1032,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 456,
    y: 1032,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 712,
    y: 1032,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 1032,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 968,
    y: 1032,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 1032,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 1288,
    y: 1032,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 1352,
    y: 1032,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 1416,
    y: 1032,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 1480,
    y: 1032,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 1096,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 584,
    y: 1096,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 1096,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 712,
    y: 1096,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 1096,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 1288,
    y: 1096,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 1352,
    y: 1096,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 1480,
    y: 1096,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 1608,
    y: 1096,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 1672,
    y: 1096,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 1736,
    y: 1096,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 1160,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 456,
    y: 1160,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 1160,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 712,
    y: 1160,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 776,
    y: 1160,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 1160,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 968,
    y: 1160,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 1096,
    y: 1160,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 1288,
    y: 1160,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 1672,
    y: 1160,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 1736,
    y: 1160,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 1224,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 1224,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 1224,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 584,
    y: 1224,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 712,
    y: 1224,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 776,
    y: 1224,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 968,
    y: 1224,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 1224,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 1096,
    y: 1224,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 1224,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 1224,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 1288,
    y: 1224,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 1352,
    y: 1224,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 1416,
    y: 1224,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 1480,
    y: 1224,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 1544,
    y: 1224,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 1736,
    y: 1224,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 712,
    y: 1288,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 776,
    y: 1288,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 1288,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 1288,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 1480,
    y: 1288,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 1736,
    y: 1288,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 712,
    y: 1352,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 1352,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 904,
    y: 1352,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 968,
    y: 1352,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 1096,
    y: 1352,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 1352,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 1352,
    y: 1352,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 1480,
    y: 1352,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 1608,
    y: 1352,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 1672,
    y: 1352,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 1736,
    y: 1352,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 904,
    y: 1416,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 1096,
    y: 1416,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 1416,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 1480,
    y: 1416,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 1544,
    y: 1416,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 712,
    y: 1480,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 1480,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 904,
    y: 1480,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 968,
    y: 1480,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 1480,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 1096,
    y: 1480,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 1480,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 1288,
    y: 1480,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 1352,
    y: 1480,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 1416,
    y: 1480,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 1480,
    y: 1480,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 1544,
    y: 1480,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 712,
    y: 1544,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 776,
    y: 1544,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 968,
    y: 1544,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 1544,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 1544,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 1352,
    y: 1544,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 1480,
    y: 1544,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 1672,
    y: 1544,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 1736,
    y: 1544,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 712,
    y: 1608,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    x: 776,
    y: 1608,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    x: 968,
    y: 1608,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 1608,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    x: 1096,
    y: 1608,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    x: 1480,
    y: 1608,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 1608,
    y: 1608,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: 1736,
    y: 1608,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 712,
    y: 1672,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    x: 968,
    y: 1672,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 1672,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 1672,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    x: 1288,
    y: 1672,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    x: 1352,
    y: 1672,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    x: 1416,
    y: 1672,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    x: 1480,
    y: 1672,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    x: 1544,
    y: 1672,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    x: 1672,
    y: 1672,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    x: 712,
    y: 1736,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    x: 776,
    y: 1736,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 1736,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    x: 1096,
    y: 1736,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 1736,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    x: 1608,
    y: 1736,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    x: 1672,
    y: 1736,
    width: 64,
    height: 64,
    fill: "#000000"
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    x: 1736,
    y: 1736,
    width: 64,
    height: 64,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 200,
    y: 200,
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    width: 448,
    height: 448,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M21.2-0.1C9.5-0.1-0.1,9.5-0.1,21.2v78.8v100v100v100v100v100v78.8c0,11.7,9.5,21.3,21.3,21.3h657.6  c11.7,0,21.3-9.5,21.3-21.3V600V500V400V300V200v-100V21.2c0-11.7-9.5-21.3-21.3-21.3H21.2z M600,200v100v100v100v87.8  c0,6.8-5.5,12.2-12.2,12.2H112.2c-6.8,0-12.2-5.5-12.2-12.2V500V400V300V200v-87.8c0-6.8,5.5-12.2,12.2-12.2h475.6  c6.8,0,12.2,5.5,12.2,12.2V200z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 200,
    y: 200,
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    width: 448,
    height: 448,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M500,400V300v-78.8c0-11.7-9.5-21.3-21.3-21.3H221.2c-11.7,0-21.3,9.5-21.3,21.3V300v100v78.8    c0,11.7,9.5,21.3,21.3,21.3h257.5c11.7,0,21.3-9.5,21.3-21.3V400z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 1352,
    y: 200,
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    width: 448,
    height: 448,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M21.2-0.1C9.5-0.1-0.1,9.5-0.1,21.2v78.8v100v100v100v100v100v78.8c0,11.7,9.5,21.3,21.3,21.3h657.6  c11.7,0,21.3-9.5,21.3-21.3V600V500V400V300V200v-100V21.2c0-11.7-9.5-21.3-21.3-21.3H21.2z M600,200v100v100v100v87.8  c0,6.8-5.5,12.2-12.2,12.2H112.2c-6.8,0-12.2-5.5-12.2-12.2V500V400V300V200v-87.8c0-6.8,5.5-12.2,12.2-12.2h475.6  c6.8,0,12.2,5.5,12.2,12.2V200z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 1352,
    y: 200,
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    width: 448,
    height: 448,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M500,400V300v-78.8c0-11.7-9.5-21.3-21.3-21.3H221.2c-11.7,0-21.3,9.5-21.3,21.3V300v100v78.8    c0,11.7,9.5,21.3,21.3,21.3h257.5c11.7,0,21.3-9.5,21.3-21.3V400z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 200,
    y: 1352,
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    width: 448,
    height: 448,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M21.2-0.1C9.5-0.1-0.1,9.5-0.1,21.2v78.8v100v100v100v100v100v78.8c0,11.7,9.5,21.3,21.3,21.3h657.6  c11.7,0,21.3-9.5,21.3-21.3V600V500V400V300V200v-100V21.2c0-11.7-9.5-21.3-21.3-21.3H21.2z M600,200v100v100v100v87.8  c0,6.8-5.5,12.2-12.2,12.2H112.2c-6.8,0-12.2-5.5-12.2-12.2V500V400V300V200v-87.8c0-6.8,5.5-12.2,12.2-12.2h475.6  c6.8,0,12.2,5.5,12.2,12.2V200z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 200,
    y: 1352,
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    width: 448,
    height: 448,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M500,400V300v-78.8c0-11.7-9.5-21.3-21.3-21.3H221.2c-11.7,0-21.3,9.5-21.3,21.3V300v100v78.8    c0,11.7,9.5,21.3,21.3,21.3h257.5c11.7,0,21.3-9.5,21.3-21.3V400z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.81a2d8fde2b35f0b68a3412cf1f4f7d3.svg";
export { ForwardRef as ReactComponent };